import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*! NanoPop 2.1.0 MIT | https://github.com/Simonwep/nanopop */
var t = "2.1.0",
    e = {
  variantFlipOrder: {
    start: "sme",
    middle: "mse",
    end: "ems"
  },
  positionFlipOrder: {
    top: "tbrl",
    right: "rltb",
    bottom: "btrl",
    left: "lrbt"
  },
  position: "bottom",
  margin: 8
},
    r = function r(t, _r, o) {
  var _container$e$o = _objectSpread(_objectSpread({
    container: document.documentElement.getBoundingClientRect()
  }, e), o),
      n = _container$e$o.container,
      i = _container$e$o.margin,
      p = _container$e$o.position,
      s = _container$e$o.variantFlipOrder,
      l = _container$e$o.positionFlipOrder,
      _r$style = _r.style,
      c = _r$style.left,
      f = _r$style.top;

  _r.style.left = "0", _r.style.top = "0";

  var m = t.getBoundingClientRect(),
      a = _r.getBoundingClientRect(),
      b = {
    t: m.top - a.height - i,
    b: m.bottom + i,
    r: m.right + i,
    l: m.left - a.width - i
  },
      d = {
    vs: m.left,
    vm: m.left + m.width / 2 + -a.width / 2,
    ve: m.left + m.width - a.width,
    hs: m.top,
    hm: m.bottom - m.height / 2 - a.height / 2,
    he: m.bottom - a.height
  },
      _p$split = p.split("-"),
      _p$split2 = _slicedToArray(_p$split, 2),
      h = _p$split2[0],
      _p$split2$ = _p$split2[1],
      u = _p$split2$ === void 0 ? "middle" : _p$split2$,
      v = l[h],
      g = s[u],
      O = n.top,
      F = n.left,
      x = n.bottom,
      j = n.right;

  var _iterator = _createForOfIteratorHelper(v),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _t = _step.value;

      var _e = "t" === _t || "b" === _t,
          _o = b[_t],
          _ref = _e ? ["top", "left"] : ["left", "top"],
          _ref2 = _slicedToArray(_ref, 2),
          _n = _ref2[0],
          _i = _ref2[1],
          _ref3 = _e ? [a.height, a.width] : [a.width, a.height],
          _ref4 = _slicedToArray(_ref3, 2),
          _p = _ref4[0],
          _s = _ref4[1],
          _ref5 = _e ? [x, j] : [j, x],
          _ref6 = _slicedToArray(_ref5, 2),
          _l = _ref6[0],
          _c = _ref6[1],
          _ref7 = _e ? [O, F] : [F, O],
          _ref8 = _slicedToArray(_ref7, 2),
          _f = _ref8[0],
          _m = _ref8[1];

      if (!(_o < _f || _o + _p > _l)) {
        var _iterator2 = _createForOfIteratorHelper(g),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _p2 = _step2.value;
            var _l2 = d[(_e ? "v" : "h") + _p2];
            if (!(_l2 < _m || _l2 + _s > _c)) return _r.style[_i] = _l2 - a[_i] + "px", _r.style[_n] = _o - a[_n] + "px", _t + _p2;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return _r.style.left = c, _r.style.top = f, null;
},
    o = function o(t, e, _o2) {
  var n = "object" != typeof t || t instanceof HTMLElement ? _objectSpread({
    reference: t,
    popper: e
  }, _o2) : t;
  return {
    update: function update() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : n;

      var _Object$assign = Object.assign(n, t),
          e = _Object$assign.reference,
          o = _Object$assign.popper;

      if (!o || !e) throw new Error("Popper- or reference-element missing.");
      return r(e, o, n);
    }
  };
};

export { o as createPopper, e as defaults, r as reposition, t as version };